var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[_c('button',{staticClass:"button",class:_vm.color == 'primary' ? 'bg-gradient-to-r from-light-blue to-green' : 'bg-white/20',attrs:{"type":_vm.type,"id":_vm.id,"disabled":_vm.isLoading}},[_vm._v(_vm._s(_vm.isLoading ? "Loading..." : _vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }